import styled from 'styled-components';

export const StyledCommunityImageBlock = styled.div`
  width: ${({ zoom }) => Math.floor(40 * zoom)}px;
  height: ${({ zoom }) => Math.floor(40 * zoom)}px;
  min-width: ${({ zoom }) => Math.floor(40 * zoom)}px;
  min-height: ${({ zoom }) => Math.floor(40 * zoom)}px;
  background-color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledCommunityImageLetter = styled.span`
  font-size: ${({ zoom }) => Math.floor(13 * zoom)}px;
  line-height: ${({ zoom }) => Math.floor(15 * zoom)}px;
  color: ${({ theme }) => theme.color.baliHai};
  user-select: none;
`;
